<!--Navigation Bar-->
<app-navbar>
    <h2>{{"PRIVACY.TITLE" | translate}}</h2>
</app-navbar>

<!--Layout Content-->
<div class="privacy-layout pt-100 pb-100">
    <div class="container">
        <div class="row">
            <!--Left Content-->
            <div class="col-lg-8 mb-5">
                <div class="col-12 bg-white pb-10">
                    <div class="job-details-item px-5 pt-5">
                        <div class="col-12 p-0">
                            <h4 class="custom-section-title">{{"PRIVACY.TITLE" | translate}}</h4>
                        </div>
                        <div class="job-description" [innerHTML]="'PRIVACY.TITLE_HTML' | translate"></div>

                        <div class="job-description">
                            <h4 class="custom-section-title"><u>{{"PRIVACY.POLICY1_TITLE" | translate}}</u></h4>
                            <div [innerHTML]="'PRIVACY.POLICY1_HTML' | translate"></div>
                        </div>

                        <div class="job-description">
                            <h4 class="custom-section-title"><u>{{"PRIVACY.POLICY2_TITLE" | translate}}</u></h4>
                            <div [innerHTML]="'PRIVACY.POLICY2_HTML' | translate"></div>
                        </div>

                        <div class="job-description">
                            <h4 class="custom-section-title"><u>{{"PRIVACY.POLICY3_TITLE" | translate}}</u>
                            </h4>
                            <div [innerHTML]="'PRIVACY.POLICY3_HTML' | translate"></div>
                        </div>

                        <div class="job-description">
                            <h4 class="custom-section-title"><u>{{"PRIVACY.POLICY4_TITLE" | translate}}</u></h4>
                            <div [innerHTML]="'PRIVACY.POLICY4_HTML' | translate"></div>
                        </div>


                        <div class="job-description">
                            <h4 class="custom-section-title"><u>{{"PRIVACY.POLICY5_TITLE" | translate}}</u></h4>
                            <div [innerHTML]="'PRIVACY.POLICY5_HTML' | translate"></div>
                        </div>

                        <div class="job-description">
                            <h4 class="custom-section-title"><u>{{"PRIVACY.POLICY6_TITLE" | translate}}</u></h4>
                            <div [innerHTML]="'PRIVACY.POLICY6_HTML' | translate"></div>
                        </div>

                    </div>
                </div>
            </div>

            <!--Right Sidebar-->
            <div class="col-lg-4 mb-5">
                <div class="col-12 p-0">
                    <h4 class="custom-section-title">{{"TERMS.INFO" | translate}}</h4>
                </div>
                <div class="col-12 bg-white">
                    <ul class="list-unstyled p-5">
                        <!--Page Link-->
                        <li class="info-pages">
                            <a routerLink="/termeni-si-conditii">
                                <i class="icofont-circled-right">
                                    <span class="ml-3">{{"TERMS.TERMS" | translate}}</span>
                                </i>
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Footer-->
<app-footer></app-footer>
